import { FAQs as SharedFAQs, FAQsImage, Text } from '@rockalingua/ui';
import Colors from '@rockalingua/ui/constants/Colors';

import { analyticsEvents } from '@/components/analytics/constants/analytics';
import trackEvent from '@/components/analytics/plausible/trackEvent';
import faqConstants from './faqConstants';
import { Container } from './FAQs.styled';

export default function FAQs() {
  const onFaqOpen = (faqId: string) => {
    trackEvent(analyticsEvents.pricingFaqOpen, {
      faq_id: faqId,
    });
  };

  return (
    <Container>
      <SharedFAQs
        image={<FAQsImage />}
        title={
          <Text variant="title-big-grey-42" color={Colors.BLACK} as="h2">
            FAQ&apos;S
          </Text>
        }
        items={faqConstants}
        onFaqOpen={onFaqOpen}
      />
    </Container>
  );
}
